export default function () {
    const pagetype = 7383;
    const loader = $("<div class='tx-solr-loader'><div class='lds-dual-ring'></div></div>");

    function clickhandler(selector) {
        $(selector).find('a.solr-ajaxified').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            $('a.solr-ajaxified').removeClass('active');
            $(e.target).addClass('active');

            $('html, body').animate({
                scrollTop: $('#tx-solr-search').offset().top,
            });

            const clickedLink = $(e.currentTarget);
            const solrContainer = clickedLink.closest('.tx_solr').find('#solr-results');
            let uri = e.currentTarget.href;

            if (uri.indexOf('?') > 0) {
                uri += `&type=${pagetype}`;
            } else {
                uri += `?type=${pagetype}`;
            }

            $(solrContainer).prepend(loader);
            $.get(uri, (data) => {
                solrContainer.html($('#solr-results', data).html());
                // read the clickhandler to new links
                clickhandler('#solr-results');
            });
            return false;
        });
    }

    clickhandler('body');
}
